import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "col gap-30 w-full" }
const _hoisted_2 = {
  key: 0,
  class: "colCenter marg-s"
}
const _hoisted_3 = {
  key: 1,
  class: "pad-m mleft-05"
}
const _hoisted_4 = {
  key: 2,
  class: "w-full col gap-30"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "pad-m mleft-05"
}

import invoiceCard from '@/views/officeMain/accounting/invoiceCard.vue';
import loadingSpinner from '@/views/loadingSpinner.vue';
import { ref, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { AccountingApi, InvoiceResponse } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { useAppUserStore } from '@/stores/appUser';
import router from '@/router';


export default /*@__PURE__*/_defineComponent({
  __name: 'dashbInvoiceHistory',
  emits: ["modal-close"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();
const currentEntryStore = useCurrentEntryStore();
const appUserStore = useAppUserStore();
const accountingApi = new AccountingApi(medServerApiConfig);

const emits = __emit;

const invoices = ref<InvoiceResponse[]>([]);
const truncated = ref(false);
const isLoading = ref(false);

const pwrPatient = computed(() => {
  return currentEntryStore.modalPatient || null;
});

const invoicesWithBalance = computed<InvoiceResponse[]>(() => {
  return invoices.value
    .filter(inv => inv.remainingBalance && inv.remainingBalance !== "0.00")
    .sort((a, b) => new Date(b.invoiceDateTime).getTime() - new Date(a.invoiceDateTime).getTime());
});

const invoicesSettled = computed(() => {
  return invoices.value
    .filter(inv => !inv.remainingBalance || inv.remainingBalance === "0.00")
    .sort((a, b) => new Date(b.invoiceDateTime).getTime() - new Date(a.invoiceDateTime).getTime());
});

function getInvoiceChannelId(invoice: InvoiceResponse) {
  // Remaining balance → no channel
  if (invoice.remainingBalance && invoice.remainingBalance !== "0.00") {
    return null;
  }
  // First secondary transaction
  if (invoice.secondaryTransactions?.length) {
    return invoice.secondaryTransactions[0].financialChannelId;
  }
  // First primary transaction
  if (invoice.transactions?.length) {
    return invoice.transactions[0].financialChannelId;
  }
  return null;
}

function navigateToInvoice(invoice: InvoiceResponse) {
  const channelId = getInvoiceChannelId(invoice);
  const isRemainingBalance = invoice.invoiceStatus !== 'Precomplete' && invoice.remainingBalance && invoice.remainingBalance !== "0.00";
  const alreadyOnAccountingIncome = router.currentRoute.value.path === '/accounting/income';

  router.push({
    path: '/accounting/income',
    query: {
      financialGroupId: invoice.financialGroup.id,
      ...(channelId != null && { channelId }),
      ...(isRemainingBalance && { channelType: 'RemainingBalance' }),
      patientId: pwrPatient.value.personWithRoleId,
      invoiceRef: invoice.invoiceReference,
    }
  });
  if (alreadyOnAccountingIncome) {
    appUserStore.setRefreshAccounting(true);
  }
  emits("modal-close");
}

async function loadInvoices() {
  if (!pwrPatient.value) {
    invoices.value = [];
    return;
  }
  isLoading.value = true;
  try {
    const result = await accountingApi.getPatientInvoices({ patientId: pwrPatient.value.personWithRoleId });
    invoices.value = result.invoices || [];
    truncated.value = result.truncated || false;
  } catch (error) {
    console.error('Failed to load patient invoices:', error);
    invoices.value = [];
  } finally {
    isLoading.value = false;
  }
}

watch(pwrPatient, () => {
  loadInvoices();
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_itemScroll = _resolveComponent("itemScroll")!

  return (_openBlock(), _createElementBlock("div", {
    class: "rnd-bottom w-full",
    onMouseover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createVNode(_component_itemScroll, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(loadingSpinner, {
                  logo: false,
                  style: 'w-3'
                })
              ]))
            : (!invoices.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('accounting.noData'),
                    styles: "main-l"
                  }, null, 8, ["txt"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (invoicesWithBalance.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('accounting.remainingBalance'),
                          class: "h4 mleft-05 pad-m"
                        }, null, 8, ["txt"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoicesWithBalance.value, (invoice) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: invoice.id
                          }, [
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "t-rowLine mleft-10" }, null, -1)),
                            _createVNode(invoiceCard, {
                              invoice: invoice,
                              currFinancialGroup: invoice.financialGroup,
                              pwrHealthPro: invoice.pwrHealthPro,
                              isTransparent: true,
                              isSelectable: false,
                              isNavigable: true,
                              onNavigate: navigateToInvoice
                            }, null, 8, ["invoice", "currFinancialGroup", "pwrHealthPro"])
                          ], 64))
                        }), 128)),
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "t-rowLine mleft-10" }, null, -1))
                      ]))
                    : _createCommentVNode("", true),
                  (invoicesSettled.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('accounting.settled'),
                          class: "h4 mleft-05 pad-m"
                        }, null, 8, ["txt"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(invoicesSettled.value, (invoice) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: invoice.id
                          }, [
                            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "t-rowLine mleft-10" }, null, -1)),
                            _createVNode(invoiceCard, {
                              invoice: invoice,
                              currFinancialGroup: invoice.financialGroup,
                              pwrHealthPro: invoice.pwrHealthPro,
                              isTransparent: true,
                              isSelectable: false,
                              isNavigable: true,
                              onNavigate: navigateToInvoice
                            }, null, 8, ["invoice", "currFinancialGroup", "pwrHealthPro"])
                          ], 64))
                        }), 128)),
                        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "t-rowLine mleft-10" }, null, -1))
                      ]))
                    : _createCommentVNode("", true),
                  (truncated.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_text_item, {
                          txt: _unref(t)('accounting.truncated'),
                          styles: "main-l"
                        }, null, 8, ["txt"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
        ])
      ]),
      _: 1
    })
  ], 32))
}
}

})